export var parents = function (element, until) {
    var result = [];
    var next = element.parentNode;
    while (next) {
        result.push(next);
        if (next === until) {
            break;
        }
        next = next.parentNode;
    }
    return result;
};



//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-popup-common/dist/es/parents.js
// module id = 148
// module chunks = 93